import axios from "axios";
import store from "@/store/index.js";
import { Message } from "element-ui";
import router from "@/router";//router要到上面
import { EventBus } from "../../main";
import VueCookies from "vue-cookies";


import APIPHP from "@/api/index.php"; // 接口配置
import APIJAVA from "@/api/index.java"; // 接口配置
import ElementUI from "element-ui";

export default {
  /*打开eip*/
  openEip(id) {
    axios.defaults.headers.common["language"] = store.state.lang;
    axios.defaults.headers.common["token"] = JSON.parse(
      localStorage.getItem("user_info")
    ).token;
    this.axios("get", `${this.php}v1/${id}`, {
      token: JSON.parse(localStorage.getItem("user_info")).token
    }).then(res => {
      if (res.code == 1) {
        window.open(res.data.url, "_blank");
      } else {
        Message({
          message: res.msg,
          type: "warning"
        });
      }
    });
  },
  // 上传图片
  uploadedImg(data) {
    if (localStorage.getItem("token")) {
      axios.defaults.headers.common["Api-Token"] = localStorage.getItem(
        "token"
      );
      axios.defaults.headers.common["Content-Type"] =
        "application/x-www-form-urlencoded";
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.php}organization/v1/companys/uploadLogo`, data)
        .then(response => {
          if (response.data.code == 20030) {
            //token过期、错误
            Message.error("token过期!");
            localStorage.removeItem("token");
            location.href = location.origin + "/web/login";
          } else {
            resolve(response.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 星号处理手机号
  noPassByMobile(str) {
    if (null != str && str != undefined) {
      var pat = /(\d{3})\d*(\d{4})/;
      return str.replace(pat, "$1****$2");
    } else {
      return "";
    }
  },
  /**
   * selectInit elements-ui select 下拉框数据格式化
   * arr 数组
   * value 返回后台的ID
   * label 显示在页面上的文案
   * options 子级数据
   * */
  selectInit(arr, value, label, options) {
    var newArr = [];
    arr.forEach(e => {
      var arrs = {};
      arrs.value = e[value];
      arrs.label = e[label];
      if (options) {
        arrs.options = [];
        arrs.options.push({
          value: e[options][value],
          label: e[options][label]
        });
      }
      newArr.push(arrs);
    });
    return newArr;
  },
  getRequest() {
    var url = window.location.search ? window.location.search : window.location.hash; //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var index = url.indexOf("?");
      var str = url.substr(index + 1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
      }
    }
    return theRequest;
  },
  //获取搜索项数据
  getSearchData(params) {
    return new Promise((resolve, reject) => {
      APIPHP.searchOptions(params)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          ElementUI.message({
            showClose: true,
            message: err,
            type: "error"
          });
          reject(err);
          console.log(err);
        });
    });
  },
  //获取开户公司
  getAccountCompany(param) {
    return new Promise((resolve, reject) => {
      APIJAVA.accountCompany(param)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          ElementUI.message({
            showClose: true,
            message: err,
            type: "error"
          });
          reject(err);
          console.log(err);
        });
    });
  },
  //开户公司下拉框（有FB平台账户的）
  getAccountCompanyFB() {
    return new Promise((resolve, reject) => {
      APIJAVA.accountCompanyFB()
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          ElementUI.message({
            showClose: true,
            message: err,
            type: "error"
          });
          reject(err);
          console.log(err);
        });
    });
  },
  //过滤---filters拿不到this-platform
  platformFilter(val, objparam) {
    let text = "-";
    if (val) {
      let keys = Object.keys(objparam);
      let values = Object.values(objparam);
      let ind = keys.findIndex(item => item == val);
      text = values[ind];
    }
    return text;
  },
  examineFilter(val) {
    //  申请状态:1 待审批,2 审批通过,3 审批失败（驳回申请）,4 操作失败(操作全部失败),5 部分成功(操作有部分失败),6 操作执行中
    let text = "";
    switch (val) {
      case 1:
        text = "待审核";
        break;
      case 2:
        text = "操作成功";
        break;
      case 3:
        text = "驳回";
        break;
      case 4:
        text = "操作失败";
        break;
      case 5:
        text = "部分成功";
        break;
      case 6:
        text = "操作执行中";
        break;
      default:
        break;
    }
    return text;
  },
  statusClassFilter(value) {
    let m = "";
    switch (value) {
      case 1:
        m = "shenpi-daishenhe";
        break;
      case 2:
        m = "shenpi-tongguo";
        break;
      case 3:
        m = "shenpi-bohui";
        break;
      case 4:
        m = "shenpi-caozuoshibai";
        break;
      case 5:
        m = "shenpi-bufenchenggong";
        break;
      case 6:
        m = "shenpi-zhixingzhong";
        break;
      default:
        break;
    }
    return m;
  },
  getClientBalance() {
    return new Promise((resolve, reject) => {
      APIJAVA.getClientBalance()
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          ElementUI.message({
            showClose: true,
            message: err,
            type: "error"
          });
          reject(err);
        })
    })
  },
  operateTypes(value) {
    let m = "";
    switch (value) {
      case 1:
        m = "绑定BM";
        break;
      case 2:
        m = "解绑BM";
        break;
      case 3:
        m = "绑定Pixel";
        break;
      case 4:
        m = "解绑Pixel";
        break;
      case 5:
        m = "账户清零";
        break;
      case 6:
        m = "拨款";
        break;
      case 7:
        m = "减款";
        break;
      case 22:
        m = "绑定BC";
        break;
      case 23:
        m = "解绑BC";
        break;
      default:
        break;
    }
    return m;
  },
  toThousands(s, n) {
    if (!s) {
      s = '0.00'
      return s
    } else {
      s = s.toString()
    }
    let is = false
    if (s.indexOf('-') == 0) {
      s = s.substr(1);
      is = true
    }
    if (n >= 0 && n <= 20) {
      s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    } else {
      s = parseFloat((s + "").replace(/[^\d\.-]/g, "")) + "";
    }
    var l = s.split(".")[0].split("").reverse(),
      r = s.split(".")[1];
    r = (r == null ? "" : "." + r);
    let t = "";
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }

    let res = t.split("").reverse().join("") + r
    if (is) {
      res = '-' + res
    }
    return res;
  },
  toLogin() {
    router.push('/login');
  },
  toRegist() {
    router.push('/regist');
  },
  toIndex() {
    router.push('/index');
  },
  getFilterPerm(url) {
    let havePerms = localStorage.getItem("userinfo") ? JSON.parse(localStorage.getItem("userinfo")).have_perms : [];
    return havePerms.findIndex(item => {
      return url == item;
    });
  },
  // 获取localStorage中userinfo中某个字段
  getUserInfoFromStorage(param) {
    let userInfo = localStorage.getItem("userinfo") ? JSON.parse(localStorage.getItem("userinfo")) : {};
    return userInfo[param] || "";
  },
  //企业信息状态不是审核通过并且是官网注册 直接跳转到企业信息页面
  quickTo(item) {
    const user_info = JSON.parse(localStorage.getItem("userinfo"));
    if (
      store.state.companyState.source == 2 &&
      [0, 1, 5].includes(store.state.companyState.status)
    ) {
      router.push({
        path: "/companyInfo",
      });
    } else {
      switch (item.type) {
        case 1:
          if (this.getFilterPerm("accountApplyGoogle") > -1) {
            EventBus.$emit("showapply", true);
          } else {
            Message({
              message: "无访问权限",
              type: "warning"
            });
          }
          break;
        case 2:
          if (this.getFilterPerm("accountOpes") > -1) {
            // 账户充值
            router.push({
              path: "/accountOpes",
              query: {
                operateType: 3,
                singlerecharge: false,
              },
            });
          } else {
            Message({
              message: "无访问权限",
              type: "warning"
            });
          }
          break;
        case 3:
          if (this.getFilterPerm("walletRecharge") > -1) {
            // 钱包充值
            router.push({
              path: user_info.client_currency === 'CNY' ? "/walletRecharge" : "/remittanceVoucher?type=2"
            });
          } else {
            Message({
              message: "无访问权限",
              type: "warning"
            });
          }
          break;
        case 4:
          if (this.getFilterPerm("accountOpes") > -1) {
            // 清零
            router.push({
              path: "/accountOpes",
              query: {
                operateType: 5,
              },
            });
          } else {
            Message({
              message: "无访问权限",
              type: "warning"
            });
          }
          break;
        case 5:
          if (this.getFilterPerm("accountOpes") > -1) {
            // 拨款
            router.push({
              path: "/accountOpes",
              query: {
                operateType: 4,
              },
            });
          } else {
            Message({
              message: "无访问权限",
              type: "warning"
            });
          }
          break;
        case 6:
          if (this.getFilterPerm("bmPixelOpes") > -1) {
            EventBus.$emit("showBMopes", true);
          } else {
            Message({
              message: "无访问权限",
              type: "warning"
            });
          }
          break;
        case 7:
          if (this.getFilterPerm("bmPixelOpes") > -1) {
            EventBus.$emit("showPixelopes", true)
          } else {
            Message({
              message: "无访问权限",
              type: "warning"
            });
          }
          break;
        case 8:
          if (this.getFilterPerm("remittanceVoucher") > -1) {
            // 钱包充值
            router.push({
              path: "/remittanceVoucher?type=2"
            });
          } else {
            Message({
              message: "无访问权限",
              type: "warning"
            });
          }
          break;
        case 101: // AI素材制作
          router.push(item.path);
          break;
        case 102: // 广告优化建议
          if (this.getFilterPerm("video-generator-list") > -1) {
            router.push(item.path);
          } else {
            Message({
              message: "无访问权限",
              type: "warning"
            });
          }
          break;
        default:
          break;
      }
    }
  },
  outLink() {
    window.open("http://beian.miit.gov.cn/");
  },
  inLink() {
    router.push("/PANDAEDI")
  },
  copyRightLink() {
    window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102011100");
  },
  scrollToBottom() {
    var container = document.querySelector(".view-area");
    container.scrollTop = container.scrollHeight;
  },
  policyScoreFilter(value) {
    let id_ = "";
    if (value === 0 || value === 1) {
      id_ = 1;
    } else if (value > 0 && value < 1) {
      id_ = 1;
    } else if (value > 1 && value < 2) {
      id_ = 2;
    } else if (value === 2) {
      id_ = 2;
    } else if (value > 2 && value < 3) {
      id_ = 3;
    } else if (value === 3) {
      id_ = 3;
    } else if (value > 3 && value < 4) {
      id_ = 4;
    } else if (value === 4) {
      id_ = 4;
    }
    return id_;
  },
  copy(text) {
    var oInput = document.createElement('input');
    oInput.value = text;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象
    document.execCommand("Copy"); // 执行浏览器复制命令
    oInput.style.display = 'none';
    Message({
      message: "复制成功",
      type: 'success'
    });
  },
  saveLoginUserToCookie(data) {
    console.log(data);
    VueCookies.set("hotpots_token_from_rocket", data.token);
    VueCookies.config(28800, "/", "panda_share");
    //, 28800, "/", "panda_share"
  },
  clearCookies() {
    // VueCookies.clear();
    VueCookies.remove("hotpots_token_from_rocket");
  },
};